
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4tTm9", function(module, exports) {

$parcel$export(module.exports, "CreateComponent", () => $1d207411f43b18d4$export$a9a76753cd947d5c);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $irVI7 = parcelRequire("irVI7");
var $8Ss4E = parcelRequire("8Ss4E");

var $kbVzJ = parcelRequire("kbVzJ");
var $aUTn5 = parcelRequire("aUTn5");

var $cZa7r = parcelRequire("cZa7r");

var $24amZ = parcelRequire("24amZ");
var $l2hqi = parcelRequire("l2hqi");

var $3jwuS = parcelRequire("3jwuS");

var $afGoD = parcelRequire("afGoD");

var $9wGTI = parcelRequire("9wGTI");

var $8Mzkb = parcelRequire("8Mzkb");
const $1d207411f43b18d4$export$a9a76753cd947d5c = ({ pageId: pageId, onCreate: onCreate, onClose: onClose, dom: selectionElement, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, closeObjectSidebar: closeObjectSidebar, isOffline: isOffline })=>{
    const { editorCreateProps: editorCreateProps } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editorNode = (0, $gwFzn.useRef)(null);
    const indexFound = (0, $gwFzn.useRef)(0);
    const textMatches = (0, $gwFzn.useRef)(0);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Required to close the sidebar once we create a new standalone comment
    (0, $gwFzn.useEffect)(()=>{
        closeObjectSidebar && editorCreateProps && (0, $9wGTI.fg)('confluence-frontend-unmount-standalone-comment') && closeObjectSidebar();
    }, [
        closeObjectSidebar,
        editorCreateProps
    ]);
    (0, $gwFzn.useEffect)(()=>{
        !(0, $9wGTI.fg)('confluence-frontend-unmount-standalone-comment') && closeObjectSidebar && closeObjectSidebar();
        (0, $8Ss4E.startEditorExperiences)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER
            }
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        }, true);
        // both editor and inline comment sidebar share the same class, target the element that isn't the sidebar
        const editorNodes = Array.from(document.querySelectorAll('.ak-editor-content-area > .ProseMirror'));
        if (editorNodes.length) {
            const foundEditorNode = editorNodes.find((element)=>!element.closest('#editor-create-sidebar'));
            if (foundEditorNode) editorNode.current = foundEditorNode;
        }
        if (selectionElement && editorNode.current && textSelection) {
            const ignoredNodes = Array.from(editorNode.current.querySelectorAll((0, $aUTn5.IGNORE_SELECTORS)));
            const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(editorNode.current, ignoredNodes);
            const { index: index, numMatches: numMatches } = (0, $kbVzJ.findMatches)(text, textSelection, // we prefer the TextNode rather than <p> or headings
            selectionElement.parentNode ? selectionElement.parentNode : selectionElement, // default to 0 since the Editor wraps the selection in a <span> now
            0, nodesStartPos, nodes);
            indexFound.current = index;
            textMatches.current = numMatches;
            if ((0, $9wGTI.fg)('confluence_frontend_mismatch_analytic_event')) {
                // Measure the newly created annotation element text length and the selection text length
                const draftAnnotationElems = document.querySelectorAll('.ak-editor-annotation-draft');
                if (draftAnnotationElems.length > 0) {
                    let draftTextContent = '';
                    draftAnnotationElems.forEach((draftAnnotationElem)=>{
                        draftTextContent += draftAnnotationElem.textContent;
                    });
                    // If they don't line up, send an event tracking it
                    if (textSelection.length !== draftTextContent.length) createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'mismatched',
                            actionSubject: 'draftText',
                            actionSubjectId: 'editPage',
                            attributes: {
                                contentId: pageId,
                                originalSelectionLength: textSelection.length,
                                draftAnnotationLength: draftTextContent.length,
                                isLivePage: isLivePage
                            },
                            source: 'annotationProvider'
                        }
                    }).fire();
                }
            }
        }
    }, [
        selectionElement,
        textSelection,
        isLivePage,
        pageId,
        closeObjectSidebar,
        createAnalyticsEvent,
        editorCreateProps
    ]);
    const selectionOptions = (0, $gwFzn.useMemo)(()=>({
            originalSelection: textSelection,
            numMatches: textMatches.current,
            matchIndex: indexFound.current,
            inlineNodeTypes: inlineNodeTypes,
            createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : (0, $afGoD.CommentCreationLocation).EDITOR
        }), [
        textSelection,
        textMatches,
        indexFound,
        isLivePage,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8Mzkb.CreateComment), {
        pageId: pageId,
        annotationElement: selectionElement,
        selectionOptions: selectionOptions,
        onClose: onClose,
        onCreate: onCreate,
        isEditor: true,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        isOffline: isOffline
    });
};

});


//# sourceMappingURL=CreateComponent.37c4d648.js.map
